import React from 'react'

const Loader = () => {
  return (
    <div className='loader'>
        <div className='loader-icon'></div>
    </div>
  )
}

export default Loader